import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import useDialogBox from "../../hooks/useDialogBox";

export default function LeftSideBar() {
  // custom Hook for status update Popup
  const [setOpen, DialogJSX] = useDialogBox();

  const history = useNavigate();
  const handelLogout = (e) => {
    e.preventDefault();
    localStorage.clear();
    history("/");
  };

  return (
    <React.Fragment>
      <div className="SidenavBar">
        <ul>
          <li className="">
            <NavLink to="/dashboard">
              <span>
                <i className="fa fa-tachometer"></i>
              </span>{" "}
              Dashboard
            </NavLink>
          </li>

          <li>
            <NavLink to="/solar-request">
              <span>
                <i className="fa fa-user"></i>
              </span>
              Solar Request
            </NavLink>
          </li>

          <li>
            <NavLink to="/user">
              <span>
                <i className="fa fa-product-hunt"></i>
              </span>
              User Management
            </NavLink>
          </li>

          <li>
            <NavLink to="/financial-partner">
              <span>
                <i className="fa fa-database"></i>
              </span>
              Financial Partner
            </NavLink>
          </li>

          <li>
            <NavLink to="/marketing-partner">
              <span>
                <i className="fa fa-user"></i>
              </span>
              Marketing Partner
            </NavLink>
          </li>

          {/* <li>
            <NavLink to="/volt-finance">
              <span>
                <i className="fa fa-product-hunt"></i>
              </span>
              Financed By Volt
            </NavLink>
          </li> */}

          <li>
            <NavLink to="/business-nature">
              <span>
                <i className="fa fa-shopping-cart"></i>
              </span>
              Nature Of Business
            </NavLink>
          </li>

          <li>
            <NavLink to="/financial-partner-type">
              <span>
                <i className="fa fa-money"></i>
              </span>
              Partner Category
            </NavLink>
          </li>

          <li>
            <NavLink to="/banner">
              <span>
                <i className="fa fa-picture-o"></i>
              </span>
              Partners Banner
            </NavLink>
          </li>

          <li>
            <NavLink to="/query">
              <span>
                <i className="fa fa-tasks"></i>
              </span>
              Queries Management
            </NavLink>
          </li>
          {/* <li>
            <NavLink to="/financial-partner-request">
              <span>
                <i className="fa fa-question-circle"></i>
              </span>
              Financial Partner Queries
            </NavLink>
          </li> */}
          <li>
            <NavLink to="/document-verification">
              <span>
                <i className="fa fa-file"></i>
              </span>
              Verification Document
            </NavLink>
          </li>

          <li>
            <NavLink to="/testimonials">
              <span>
                <i className="fa fa-star"></i>
              </span>
              Testimonials
            </NavLink>
          </li>
  <li>
            <NavLink to="/jobs">
              <span>
                <i className="fa fa-star"></i>
              </span>
              Jobs Management
            </NavLink>
          </li>
          <li>
            <NavLink to="/blogs">
              <span>
                <i className="fa fa-newspaper-o"></i>
              </span>
              Blog Management
            </NavLink>
          </li>
          <li>
            <NavLink to="/content-management">
              <span>
                <i className="fa fa-files-o"></i>
              </span>
              CMS Management
            </NavLink>
          </li>

          <li>
            <NavLink to="/settings">
              <span>
                <i className="fa fa-cogs"></i>
              </span>
              Settings
            </NavLink>
          </li>
          <li>
            <NavLink to="/change-password">
              <span>
                <i className="fa fa-cog"></i>
              </span>
              Change Password
            </NavLink>
          </li>

          <li>
            <a onClick={()=>setOpen(true)}>
              <span>
                <i className="fa fa-sign-out"></i>
              </span>
              Logout
            </a>
          </li>
        </ul>
      </div>
      {/* Add DialogBox for Update status popUp */}
      <DialogJSX
        title="Logout"
        bodyTitle="Are you sure want to Logout?"
        final={handelLogout}
      />
    </React.Fragment>
  );
}
